<div>
  <app-navigation></app-navigation>
  <router-outlet *ngIf="!loading"></router-outlet>
</div>
<router-outlet name="print"></router-outlet>

<div class="spinner"
     *ngIf="loading">
  <p-progressSpinner> </p-progressSpinner>
</div>
